import React from "react";
import ConfirmationModal from "../../commonComponents/shared/ConfirmationModal";
import LoadingSpinner from "../../commonComponents/util/LoadingSpinner";
import NavigationComponent from "../../commonComponents/util/NavigationComponent";
import { formatDate, formatCurrency } from "../../../lib/utils";

export default class ReconciliationReports extends NavigationComponent {
  state = {
    selectedReportId: null,
    showModals: {
      confirmUndoReconciliationReportModal: false
    }
  };

  componentWillMount() {
    this.getReports();
  }

  async getReports() {
    await this.props.getReports(this.props.fundId);
  }

  onClickUndoReport = reportId => {
    this.setState(
      {
        selectedReportId: reportId
      },
      () => this.toggleModal("confirmUndoReconciliationReportModal")
    );
  };

  undoReconciliationReport = async () => {
    await this.props.deleteReport(
      this.props.fundId,
      this.state.selectedReportId
    );
    if (this.props.deleteReconciliationReport.success) {
      this.setState({
        selectedReportId: null
      });
    }
  };

  render() {
    return (
      <div>
        {this.props.reconciliationReports.loading ? (
          <LoadingSpinner height={32} />
        ) : (
          <div className="bank-reconciliation">
            {this.props.reconciliationReports.data.reports &&
            this.props.reconciliationReports.data.reports.length ? (
              <div>
                <h4 className="large-text">
                  Previous Bank Reconciliation Reports
                </h4>
                {<table className="table bank-reconciliation-reports">
                  <thead>
                    <tr>
                      <th>Report Name</th>
                      <th>Bank Statement Balance</th>
                      <th>Statement Dates</th>
                      <th>Undo</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                  {this.props.reconciliationReports.data.reports.map(report => 
                    <tr key={report.reportId}>
                      <td className="bold-text medium-text">
                          {report.reportName}
                        </td>
                        <td className="bold-text medium-text">
                          {formatCurrency(report.bankStatementBalance)}
                        </td>
                        <td className="medium-text">{`${formatDate(
                          report.dateFrom
                        )} - ${formatDate(report.dateTo)}`}</td>
                            <td className="bank-reconciliation-right-column text-center">
                            {report.canBeDeleted && this.props.permissions.manageAccounting && (
                              <i
                                className="icon-action-undo icon-left accent-text"
                                onClick={() =>
                                  this.onClickUndoReport(report.reportId)
                                }
                              />)}
                            </td>
                            <td className="text-center">
                            {this.props.permissions.report && (
                          <button
                            className="btn btn-flat btn-flat-accent2"
                            onClick={() =>
                              this.props.downloadReport(
                                report.reportId,
                                report.reportName
                              )
                            }
                          >
                            New Report
                          </button>
                        )}
                              </td>
                    </tr>
                    )}
                  </tbody>
              </table>}
              </div>
            ) : (
              <p className="empty-state"><i className="material-icons">not_interested</i>No Reports Available</p>
            )}
          </div>
        )}

        <ConfirmationModal
          close={() => {
            this.toggleModal("confirmUndoReconciliationReportModal");
            this.setState({ selectedReportId: null });
          }}
          confirm={this.undoReconciliationReport}
          loading={this.props.deleteReconciliationReport.loading}
          message="Are you sure you want to delete this reconciliation report?"
          show={this.state.showModals.confirmUndoReconciliationReportModal}
          success={this.props.deleteReconciliationReport.success}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/accountingComponents/fundDetails/ReconciliationReports.jsx